import clsx from 'clsx'

import { FileCategory } from '@makyoapp/makyo-sdk/models/Files'

import { ReactComponent as ArchiveIcon } from '@/assets/archive.svg?react'
import { ReactComponent as BriefcaseIcon } from '@/assets/briefcase.svg?react'
import { ReactComponent as DocIcon } from '@/assets/document.svg?react'
import { ReactComponent as ImageIcon } from '@/assets/image.svg?react'
import { ReactComponent as AudioIcon } from '@/assets/music.svg?react'
import { ReactComponent as VideoIcon } from '@/assets/video.svg?react'

interface Props {
  ty: FileCategory | 'all'
  svgProps?: React.ComponentPropsWithoutRef<'svg'>
  className?: string
  size?: 'normal' | 'small'
}

export function StorageTypeIcon({ ty, svgProps, className, size = 'normal' }: Props) {
  let el
  switch (ty) {
    case 'image':
      el = <ImageIcon {...svgProps} />
      break
    case 'audio':
      el = <AudioIcon {...svgProps} />
      break
    case 'video':
      el = <VideoIcon {...svgProps} />
      break
    case 'document':
      el = <DocIcon {...svgProps} />
      break
    case 'other':
      el = <ArchiveIcon {...svgProps} />
      break
    default:
      el = <BriefcaseIcon {...svgProps} />
      break
  }

  return (
    <div
      className={clsx(
        'mk-storage-cat-icon',
        size === 'normal' ? 'mk-storage-cat-icon-nm' : 'mk-storage-cat-icon-sm',
        `mk-storage-cat-icon-${ty}`,
        className
      )}
    >
      {el}
    </div>
  )
}
